import NewAcceptingOrderFields from 'components/accepting_orders/new_accepting_order_fields.vue'
import EditAcceptingOrderFields from 'components/accepting_orders/edit_accepting_order_fields.vue'

export default {
  components: {
    NewAcceptingOrderFields,
    EditAcceptingOrderFields,
  },
  data: () => ({
    message: 'A'
  })
}